<template>
  <base-page-layout :hideBreadcrumbs="false" showBackButton backRouter="/produtos/gerenciamento-produtos">
    <v-row class="px-2">
      <v-col class="d-flex" cols="9">
        <h2 class="ma-0 page-title">{{ product.name }}</h2>
        <product-chips :product-forms="product" :plataform="plataform" :is-create="isCreate" :is-loading="isProductLoading" is-product />
      </v-col>
      <v-col v-if="!isProductLoading" cols="3" class="d-flex justify-end align-center">
        <mf-button
          v-if="!isCreate && product.legacySku"
          label="Ver métricas"
          outlined
          text-transform="none"
          icon="monitoring"
          icon-position="left"
          class="offer-results-button mr-3"
          @click="emitResultsFunction"
        />
        <div v-if="!isCreate" class="pl-2 pr-1 d-flex align-center justify-center" :class="product.active ? 'active-item' : 'inactive-item'">
          <span>{{ product.active ? 'Produto ativo' : 'Produto inativo' }}</span>
          <mf-toggle v-model="product.active" class="ml-4" hide-details :disabled="!userHasPermission" />
        </div>
      </v-col>
    </v-row>
    <mf-tabs-menu v-model="tab" :tabs="tabs" class="mb-5" />
    <mf-loading-dialog :loading="isProductLoading" />
    <div v-if="tab === 0">
      <product-info-card
        v-model="product"
        :sku-validate="validLegacySku"
        :validation="$v"
        :is-product-loading="isProductLoading"
        :is-create="isCreate"
        :show-tooltip="showTooltip"
        :measures="measures"
        :loading-image.sync="loadingImage"
      />
      <product-weights-measures v-if="$getLoggedUser().has_ecommerce" v-model="product" :validation="$v" :measures="measures" />
      <product-removal v-if="$getLoggedUser().has_ecommerce" v-model="product" />
      <product-variations v-if="$getLoggedUser().has_ecommerce" v-model="product" :validation="$v" />
    </div>
    <v-row class="py-8 px-4">
      <mf-button label="Cancelar" outlined @click="returnWindow(false)" />
      <v-spacer></v-spacer>
      <mf-button class="mr-3" label="Salvar e continuar" outlined :disabled="loadingImage || loading" @click="checkForm(true)" />
      <mf-button label="Salvar e sair" :disabled="loadingImage || loading" @click="checkForm" />
    </v-row>
    <dialog-products
      v-if="dialog"
      :dialog="dialog"
      :items="items"
      :eans="product.eans"
      @action="saveDuplicateEan"
      @cancel="returnWindow(true)"
    ></dialog-products>
  </base-page-layout>
</template>

<script>
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import { notOnlySpace } from '@/helpers/validators.js'
import {
  QUERY_GET_PRODUCT_BY_ID,
  MUTATION_CREATE_PRODUCT,
  MUTATION_UPDATE_PRODUCT,
  QUERY_GET_MEASURES,
  MUTATION_CLEAN_PRODUCTS_DUPLICATES,
} from '../../../graphql'
import { deepDelete } from '@/helpers/deepDelete'
export default {
  name: 'CreateEditProduct',
  components: {
    BasePageLayout: () => import('@/components/BasePageLayout.vue'),
    ProductInfoCard: () => import('./ProductInfoCard.vue'),
    ProductWeightsMeasures: () => import('./ProductWeightsMeasures.vue'),
    ProductRemoval: () => import('./ProductRemoval.vue'),
    ProductVariations: () => import('../../components/ProductVariations.vue'),
    ProductChips: () => import('../../components/ProductChips.vue'),
    DialogProducts: () => import('../../components/DialogProducts.vue'),
  },
  data: () => ({
    dialog: false,
    loadingImage: false,
    forcePush: false,
    isProductLoading: false,
    isCreate: false,
    loading: false,
    tab: 0,
    measures: [],
    items: [],
    validLegacySku: '',
    plataform: '',
    showTooltip: false,
    product: {
      ecommerceId: '',
      legacySku: '',
      catalogId: '',
      productMfId: '',
      departmentId: '',
      departmentMfId: '',
      categoryId: '',
      categoryMfId: '',
      ecommerceCategoryId: '',
      subcategoryId: '',
      subcategoryMfId: '',
      brandId: '',
      brandMfId: '',
      ecommerceBrandId: '',
      departmentMf: {
        name: '',
      },
      categoryMf: {
        name: '',
      },
      subcategoryMf: {
        name: '',
      },
      brandMf: {
        name: '',
      },
      measure: {
        acronym: '',
        active: false,
        fractionalSale: false,
        name: '',
      },
      isWeightable: false,
      measureMfId: '',
      eans: [],
      name: '',
      images: [
        {
          isMain: true,
          url: '',
          urlThumbnail: '',
          urlMiniature: '',
          order: '',
        },
      ],
      quantityDescription: '',
      description: '',
      initialWeight: '1',
      additionWeight: '2',
      nutritionalTable: '',
      isMedicine: false,
      activePrinciple: '',
      leaflet: '',
      deliveryRestriction: {
        active: false,
      },
      longName: '',
      keywords: '',
      gpc: '',
      ncm: '',
      height: '',
      width: '',
      depth: '',
      grossWeight: '',
      netWeight: '',
      totalAmountPackaging: '',
      content: '',
      measureContent: '',
      ingredients: '',
      recommendationsForUse: '',
      variations: [],
      synonyms: [],
      manuallyEdited: true,
      erpName: '',
      active: true,
    },
  }),
  provide: function () {
    return {
      userHasPermission: this.userHasPermission,
    }
  },
  computed: {
    userPermissions() {
      return this.$getLoggedUser().ecommercePermissions.includes('change_modelo') ?? false
    },
    userHasPermission() {
      if (this.$getLoggedUser().has_club || (this.$getIsEcommerce() && this.userPermissions) || this.$getLoggedUser().has_mercapromo) {
        return true
      }

      return false
    },
    tabs() {
      return [
        {
          name: this.isCreate ? 'Novo Produto' : 'Dados cadastrais',
          haveLength: false,
        },
      ]
    },
  },
  mounted() {
    this.getMeasures()
    if (this.$route.params.id) {
      this.getProductById(this.$route.params.id)
    } else {
      this.isCreate = true
      this.showTooltip = this.$getLoggedUser().has_club
    }
  },
  methods: {
    async saveDuplicateEan(product) {
      this.dialog = false
      const confirmed = await this.$confirm({
        message: 'Deseja confirmar esta ação? Ao confirmar, os demais produtos que não tiverem outro EAN serão inativados.',
        confirmText: 'Continuar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) {
        this.dialog = true
        return
      }
      this.isProductLoading = true
      this.$apollo
        .mutate({
          mutation: MUTATION_CLEAN_PRODUCTS_DUPLICATES,
          variables: {
            cleanProductsDuplicatesId: product.id,
            eans: product.eans,
          },
          context: {
            uri: this.$microservicesUrls['fedGateway'],
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          this.$snackbar({ message: 'Produto atualizado com sucesso.', snackbarColor: 'success' })
          window.location.reload()
        })
        .catch(() => {
          this.dialog = true
          this.$snackbar({ message: 'Erro ao atualizar os eans.', snackbarColor: 'error' })
        })
        .finally(() => (this.isProductLoading = false))
    },
    returnWindow(forcePush) {
      this.forcePush = forcePush
      this.$router.push('/produtos/gerenciamento-produtos')
    },
    async getProductById(id) {
      try {
        this.isProductLoading = true

        const {
          data: { findProductById },
        } = await this.$apollo.query({
          query: QUERY_GET_PRODUCT_BY_ID,
          variables: { id },
          context: {
            uri: this.$microservicesUrls['fedGateway'],
          },
          fetchPolicy: 'network-only',
        })

        const clonedProduct = {
          ...findProductById,
          images: [...(findProductById.images || [])],
        }

        this.product = clonedProduct
        this.validLegacySku = clonedProduct.legacySku
        this.showTooltip = this.$getLoggedUser().has_club && !clonedProduct.legacySku
        if (clonedProduct.duplicates) {
          this.dialog = true

          this.items = clonedProduct.duplicates.map((i) => {
            return { ...i, activeValue: false, showLink: true }
          })
          this.items[0].activeValue = true
          this.items[0].showLink = false
        }
        if (clonedProduct.measureMfId) {
          const measure = {
            id: clonedProduct.measureMfId,
            ...clonedProduct.measure,
          }
          this.product.measure = measure
        }
        if (this.product.cbm && this.product.ecommerce) {
          this.plataform = 'CBM/E-commerce'
        } else if (this.product.cbm && !this.product.ecommerce) {
          this.plataform = 'CBM'
        } else if (!this.product.cbm && this.product.ecommerce) {
          this.plataform = 'E-commerce'
        }
        if (!clonedProduct.measure) {
          this.product.measure = {
            acronym: '',
            active: false,
            fractionalSale: false,
            name: '',
          }
        }
        if (this.product?.initialWeight === '') this.product.initialWeight = '1'
        if (this.product?.additionWeight === '') this.product.additionWeight = '2'
        if (!clonedProduct.images.length) {
          this.product.images = [
            {
              isMain: true,
              url: '',
              urlThumbnail: '',
              urlMiniature: '',
              order: '',
            },
          ]
        }
      } catch (error) {
        this.$snackbar({ message: 'Erro ao buscar produto', snackbarColor: 'error' })
      } finally {
        this.isProductLoading = false
      }
    },
    checkForm(stayScreen) {
      this.$v.$touch()

      if (this.$v.$error) {
        this.$snackbar({ message: 'Preencha todos os campos corretamente', snackbarColor: 'error' })
        this.scrollWindowToError('.error--text')

        return
      }

      this.formatBeforeSave(stayScreen)
    },
    assignFieldIfExists(findProductById, fieldName) {
      if (findProductById[fieldName]) {
        this.product = Object.assign(findProductById, { [fieldName]: { ...findProductById[fieldName] } })
      }
    },
    async formatBeforeSave(stayScreen) {
      const formattedProduct = structuredClone(this.product)
      this.forcePush = true
      if (!formattedProduct.brandId) formattedProduct.brandId = ''
      if (!formattedProduct.subcategoryId) formattedProduct.subcategoryId = ''

      if (formattedProduct.isWeightable || formattedProduct.measure.hasOwnProperty('id') || formattedProduct.measure.hasOwnProperty('__typename')) {
        formattedProduct.measureMfId = formattedProduct.measure.id
        delete formattedProduct.measure.id
        delete formattedProduct.measure.__typename
      }
      delete formattedProduct.departmentMf
      delete formattedProduct.categoryMf
      delete formattedProduct.subcategoryMf
      delete formattedProduct.brandMf

      if (!formattedProduct.brandId) formattedProduct.brandId = ''

      if (this.isCreate) {
        formattedProduct.eans.forEach((ean) => {
          ean.ean = ean.ean.toString()

          if (ean.packingQuantity.quantityPackaging) {
            ean.packingQuantity.quantityPackaging = ean.packingQuantity.quantityPackaging.toString()
          }
        })

        this.createProduct(formattedProduct, stayScreen)
        return
      }

      delete formattedProduct.deliveryRestriction.__typename
      delete formattedProduct.images.forEach((image) => {
        delete image.__typename
      })

      formattedProduct.eans.forEach((ean) => {
        ean.ean = ean.ean.toString()

        if (ean.packingQuantity.quantityPackaging) {
          ean.packingQuantity.quantityPackaging = ean.packingQuantity.quantityPackaging.toString()
        }

        delete ean.__typename
        delete ean.packingQuantity.__typename
      })

      if (formattedProduct.variations && formattedProduct.variations.length) {
        formattedProduct.variations.forEach((variation) => {
          delete variation.__typename
        })
      }
      await deepDelete(formattedProduct, ['__typename', 'slug', 'duplicates', 'cbm', 'ecommerce', 'productMfname', 'productMfId', 'erpCategories'])

      this.updateProduct(formattedProduct, stayScreen)
    },
    createProduct(product, stayScreen) {
      this.loading = true

      this.$apollo
        .mutate({
          mutation: MUTATION_CREATE_PRODUCT,
          variables: {
            data: product,
          },
          context: {
            uri: this.$microservicesUrls['fedGateway'],
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          this.$snackbar({ message: 'Produto criado com sucesso.', snackbarColor: 'success' })
          if (stayScreen) {
            this.$router.push({ path: `/produtos/alterar/${data.createProduct.id}` }).then(() => {
              window.location.reload()
            })
          } else {
            this.$router.push('/produtos/gerenciamento-produtos')
          }
        })
        .catch((error) => {
          if (error.message === 'GraphQL error: Product With Same Ean Already Exist Error') {
            this.$snackbar({ message: 'Já existe um produto com um dos eans criados.', snackbarColor: 'error' })

            return
          }

          if (error.message === 'GraphQL error: Product With Same Sku Already Exist Error') {
            this.$snackbar({ message: 'Já existe um produto criado com este SKU.', snackbarColor: 'error' })

            return
          }

          this.$snackbar({ message: 'Erro ao criar produto.', snackbarColor: 'error' })
        })
        .finally(() => (this.loading = false))
    },
    updateProduct(product, stayScreen) {
      this.loading = true

      this.$apollo
        .mutate({
          mutation: MUTATION_UPDATE_PRODUCT,
          variables: {
            data: product,
          },
          context: {
            uri: this.$microservicesUrls['fedGateway'],
          },
          fetchPolicy: 'no-cache',
        })
        .then(() => {
          this.$snackbar({ message: 'Produto editado com sucesso.', snackbarColor: 'success' })
          if (stayScreen) {
            window.location.reload()
          } else {
            this.$router.push('/produtos/gerenciamento-produtos')
          }
        })
        .catch((error) => {
          if (error.message === 'GraphQL error: Product With Same Ean Already Exist Error') {
            this.$snackbar({ message: 'Já existe um produto com um dos eans criados.', snackbarColor: 'error' })

            return
          }

          if (error.message === 'GraphQL error: Product With Same Sku Already Exist Error') {
            this.$snackbar({ message: 'Já existe um produto criado com este SKU.', snackbarColor: 'error' })

            return
          }

          this.$snackbar({ message: 'Erro ao editar produto.', snackbarColor: 'error' })
        })
        .finally(() => (this.loading = false))
    },
    getMeasures() {
      this.loading = true

      this.$apollo
        .query({
          query: QUERY_GET_MEASURES,
          variables: {
            page: 1,
            pageSize: 100,
          },
          context: {
            uri: this.$microservicesUrls['fedGateway'],
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data: { listMeasure } }) => {
          this.measures = listMeasure.measures
        })
        .catch(() => this.$snackbar({ message: 'Erro ao buscar medidas.', snackbarColor: 'error' }))
        .finally(() => (this.loading = false))
    },
    scrollWindowToError(querySelector) {
      this.$nextTick(() => {
        let element = document.querySelector(querySelector)
        if (element) {
          this.$vuetify.goTo(element, { offset: 200 })
        } else {
          window.scrollTo(0, 0)
        }
      })
    },
    emitResultsFunction() {
      const route = this.$router.resolve({ name: 'detalhes-produto', params: { id: this.product.legacySku } })
      window.open(route.href, '_blank')
    },
  },
  validations() {
    const product = {
      name: {
        required,
        minValue: minLength(1),
        maxLength: maxLength(250),
        notOnlySpace,
      },
      eans: {
        required,
        minLength: minLength(1),
        $each: {
          ean: {
            required,
          },
        },
      },
      description: {
        maxLength: maxLength(5000),
        notOnlySpace,
      },
      nutritionalTable: {
        maxLength: maxLength(5000),
        notOnlySpace,
      },
    }

    if (this.isCreate) {
      product.legacySku = {
        required,
        maxLength: maxLength(100),
      }
    }

    if (this.$getLoggedUser().has_ecommerce) {
      product.quantityDescription = {
        maxLength: maxLength(8),
      }
    }

    if (this.product.variations && this.product.variations.length) {
      product.variations = {
        $each: {
          name: {
            maxLength: maxLength(30),
            required,
            notOnlySpace,
          },
          percentage: {
            required,
            maxLength: maxLength(8),
            minValue: function (value) {
              return parseFloat(value) > 0
            },
          },
          isDefault: function () {
            return this.product.variations.some((variation) => variation.isDefault)
          },
        },
      }
    }

    if (this.product.isWeightable) {
      product.measure = {
        name: {
          required,
          minLength: minLength(1),
        },
      }

      if (this.product.measure.fractionalSale) {
        if (this.$getLoggedUser().has_ecommerce) {
          product.additionWeight = {
            required,
            minValue: function (value) {
              return parseFloat(value) > 0
            },
          }
        }
      }
    }

    if (this.product.departmentId) {
      product.categoryId = {
        required,
      }
    }

    return { product }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.forcePush) {
      this.$confirm({
        title: 'Tem certeza?',
        message: 'Suas alterações ainda não foram salvas e todas as suas alterações recentes serão perdidas ao sair dessa página.',
        confirmText: this.isCreate ? 'Ficar e continuar criação' : 'Ficar e continuar edição',
        cancelText: 'Sair da tela',
      })
        .then(() => {
          next(false)
        })
        .catch(() => {
          next()
        })
    } else {
      next()
    }
  },
}
</script>

<style lang="scss" scoped>
.active-item {
  width: 170px;
  height: 40px;
  border: 1px solid $marca-1;
  border-radius: 6px;

  ::v-deep .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
  }
}

.inactive-item {
  width: 170px;
  height: 40px;
  border: 1px solid $cinza-l40;
  border-radius: 6px;

  ::v-deep .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
  }
}
</style>
